import { render, staticRenderFns } from "./ReportsCreate.vue?vue&type=template&id=5354f0f6&"
import script from "./ReportsCreate.vue?vue&type=script&lang=js&"
export * from "./ReportsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports